//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './PriceListsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetPriceListsQueryParameters = {
  request?: Types.PriceListsRequestDto | undefined ;
}

export function getUrl(request?: Types.PriceListsRequestDto | undefined): string {
  let url_ = getBaseUrl() + "/api/price-lists?";
if (request === null)
    throw new Error("The parameter 'request' cannot be null.");
else if (request !== undefined)
    url_ += "request=" + encodeURIComponent("" + request) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.PriceListsResponseDto, unknown, Types.PriceListsResponseDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PriceListsResponseDto, unknown, Types.PriceListsResponseDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(request?: Types.PriceListsRequestDto | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { request,  } = params[0] as GetPriceListsQueryParameters;

    return trimArrayEnd([
        'PriceListsClient',
        'get',
        request as any,
      ]);
  } else {
    return trimArrayEnd([
        'PriceListsClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as Types.PriceListsRequestDto | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.PriceListsResponseDto, TError = unknown>(dto: GetPriceListsQueryParameters, options?: Omit<UseQueryOptions<Types.PriceListsResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets data.
 * @param request (optional) 
 */
export function useGetQuery<TSelectData = Types.PriceListsResponseDto, TError = unknown>(request?: Types.PriceListsRequestDto | undefined, options?: Omit<UseQueryOptions<Types.PriceListsResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.PriceListsResponseDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PriceListsResponseDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let request: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ request,  } = params[0] as GetPriceListsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [request, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PriceListsResponseDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(request),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.PriceListsResponseDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets data.
 * @param request (optional) 
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.PriceListsResponseDto | undefined) => Types.PriceListsResponseDto, request?: Types.PriceListsRequestDto | undefined) {
  queryClient.setQueryData(getQueryKey(request),
    updater
  );
}

/**
 * Gets data.
 * @param request (optional) 
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PriceListsResponseDto | undefined) => Types.PriceListsResponseDto) {
  queryClient.setQueryData(queryKey, updater);
}